export default __webpack_public_path__ + "static/media/CodingNinjas.26d70dce.png";